"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logOut = void 0;
const utils_fetch_1 = __importDefault(require("@gcloud-npm/utils.fetch"));
const utils_monitoring_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.sonda"));
const utils_monitoring_get_uuid_1 = __importDefault(require("@gcloud-npm/utils.monitoring.get-uuid"));
const processName = "ADABYRON-API";
let URL_API = `/cliente/api/gestioncredenciales/logout?`;
function logOut({ context, build = false }) {
    const idRequest = (0, utils_monitoring_get_uuid_1.default)('NC');
    let finalPath = `${URL_API}${idRequest}`;
    const { environment, } = context;
    const { telco: connectionData } = environment;
    const { endpoint: host } = connectionData;
    let sonda = null;
    if (!build) {
        // importo sonda
        sonda = new utils_monitoring_sonda_1.default({
            eventName: "ABS_LAYER.LOGOUT",
            context,
            uniqueId: idRequest,
            origin: processName,
        });
    }
    finalPath = `${host}${finalPath}`;
    const request = new utils_fetch_1.default({
        method: "GET",
        endpoint: finalPath,
        data: null,
        sonda,
    });
    return request.makeRequest();
}
exports.logOut = logOut;
exports.default = logOut;
//# sourceMappingURL=index.js.map